var swiper = new Swiper('.mySwiper-annoucement', {
    direction: 'horizontal',
    loop: true,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    grabCursor: true,
    mousewheel: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
        nextEl: '.announcement-ofra-container .swiper-button-next',
        prevEl: '.announcement-ofra-container .swiper-button-prev',
    },
});
function setCookie(name, value, hours) {
    const date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
    const cname = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
    }
    return "";
}

if (getCookie("hideAnnouncementOfra") === "true") {
    document.querySelector(".announcement-ofra-container").style.display = "none";
}


document.querySelector(".announcement-ofra__nav-button-close").addEventListener("click", function () {
    document.querySelector(".announcement-ofra-container").style.display = "none";
    setCookie("hideAnnouncementOfra", "true", 0.1667);
});

window.addEventListener("scroll", function () {
    const banner = document.querySelector(".announcement-ofra-container");
    if (window.scrollY > 0) {
        banner.style.display = "none";
    } else {
        if (getCookie("hideAnnouncementOfra") !== "true") {
            banner.style.display = "block";
        }
    }
});